/** =========================================================
 * Module: item-edit-button.directive.js
 * Edit item button
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemEditButton', itemEditButton);

  itemEditButton.$inject = ['$rootScope'];

  function itemEditButton($rootScope) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/components/item-edit-button.html',
      link: function ($scope) {
        var action = 'edit';

        $scope.enabled = false;

        function checkEnabled() {
          if ($scope.config && $scope.config.model && $scope.config[action]) {
            if (typeof $scope.config[action].permission !== 'undefined') {
              return $scope.config[action].permission;
            }

            return $rootScope.helpers.hasPermissionTo($scope.config.model + ' ' + action);
          }

          return false;
        }

        if ($scope.item !== 'undefined') {
          $scope.enabled = checkEnabled();
        }

        $scope.$watch('item', function (item) {
          if (typeof item !== 'undefined') {
            $scope.enabled = checkEnabled();
          }
        });
      },
      scope: {
        config: '=',
        item: '=',
        template: '@?'
      }
    };

    return directive;
  }
})();
